export default __webpack_public_path__ + "static/media/fastFood06.15d13730.png";